<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header {{{o.type}}}">
        <h5 class="modal-title">{{{o.title}}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">{[o.messages.forEach(function (message) { ]}
          <p>{{{message}}}</p>
      {[ }) ]}
    </div>
    </div>
  </div>
</div>
